(() => {
  'use strict';
  const VERSION = '7.0.1';
  const NS = 'http://www.w3.org/1999/xlink';
  const setHref = (node, value) => {
    if (!node) return;
    if (!value) { node.removeAttribute('href'); node.removeAttribute('xlink:href'); return; }
    node.setAttribute('href', value);
    node.setAttributeNS(NS, 'xlink:href', value);
  };
  const number = (value, fallback) => Number.isFinite(Number(value)) ? Number(value) : fallback;
  const setRect = (node, box) => {
    if (!node) return;
    node.setAttribute('x', box.x.toFixed(2));
    node.setAttribute('y', box.y.toFixed(2));
    node.setAttribute('width', box.width.toFixed(2));
    node.setAttribute('height', box.height.toFixed(2));
    if (box.rx != null) node.setAttribute('rx', box.rx.toFixed(2));
  };
  const contain = (iw, ih, frame) => {
    const ratio = Math.min(frame.width / iw, frame.height / ih);
    const width = iw * ratio;
    const height = ih * ratio;
    return { x: frame.x + (frame.width - width) / 2, y: frame.y + (frame.height - height) / 2, width, height };
  };
  const cover = (iw, ih, frame) => {
    const ratio = Math.max(frame.width / iw, frame.height / ih);
    const width = iw * ratio;
    const height = ih * ratio;
    return { x: frame.x + (frame.width - width) / 2, y: frame.y + (frame.height - height) / 2, width, height };
  };

  const init = (root) => {
    if (!root || root.dataset.ufProductAware701Ready === 'true' || root.dataset.ufProductAware !== 'true') return;
    const preview = root.querySelector('[data-uf-product-preview]');
    const designer = root.querySelector('[data-uf-designer]');
    const svg = root.querySelector('[data-uf-canvas-svg]');
    if (!preview || !designer || !svg) return;
    root.dataset.ufProductAware701Ready = 'true';
    root.dataset.ufProductView = 'product';
    root.dataset.ufEngravingSimulation = root.dataset.ufEngravingSimulation || 'multiply';
    root.style.setProperty('--uf-product-opacity', root.dataset.ufProductImageOpacity || '.9');

    const sideButtons = [...root.querySelectorAll('[data-uf-side]')];
    const viewButtons = [...root.querySelectorAll('[data-uf-product-view]')];
    const opacity = root.querySelector('[data-uf-product-opacity]');
    const safe = svg.querySelector('.uf-designer__safe-zone');
    const clip = svg.querySelector('[data-uf-product-clip-rect]');
    const shadow = svg.querySelector('[data-uf-product-shadow]');
    const frame = { x: 18, y: 18, width: 564, height: 324 };
    const insetX = Math.max(0, Math.min(45, number(root.dataset.ufSafeInsetX, 10))) / 100;
    const insetY = Math.max(0, Math.min(45, number(root.dataset.ufSafeInsetY, 10))) / 100;
    const fit = root.dataset.ufProductImageFit === 'slice' ? 'slice' : 'meet';
    const imageFor = (side) => side === 'back' ? root.dataset.ufBackProductImage : root.dataset.ufFrontProductImage;
    let layoutToken = 0;

    const updateLayout = (url) => {
      const token = ++layoutToken;
      if (!url) return;
      const image = new Image();
      image.onload = () => {
        if (token !== layoutToken) return;
        const naturalW = Math.max(1, image.naturalWidth || image.width || 1);
        const naturalH = Math.max(1, image.naturalHeight || image.height || 1);
        const productBox = fit === 'slice' ? cover(naturalW, naturalH, frame) : contain(naturalW, naturalH, frame);
        const radius = Math.min(22, productBox.width * .04, productBox.height * .04);
        setRect(preview, productBox);
        preview.setAttribute('preserveAspectRatio', 'none');
        setRect(clip, { ...productBox, rx: radius });
        setRect(shadow, { ...productBox, rx: radius });
        const safeBox = {
          x: productBox.x + productBox.width * insetX,
          y: productBox.y + productBox.height * insetY,
          width: productBox.width * (1 - insetX * 2),
          height: productBox.height * (1 - insetY * 2),
          rx: Math.max(8, radius * .65)
        };
        setRect(safe, safeBox);
        safe.dataset.ufSafeX = safeBox.x.toFixed(2);
        safe.dataset.ufSafeY = safeBox.y.toFixed(2);
        safe.dataset.ufSafeWidth = safeBox.width.toFixed(2);
        safe.dataset.ufSafeHeight = safeBox.height.toFixed(2);
        root.style.setProperty('--uf-product-box-x', `${productBox.x}px`);
        root.style.setProperty('--uf-product-box-y', `${productBox.y}px`);
        designer.dispatchEvent(new CustomEvent('uf:product-canvas-layout', {
          bubbles: true,
          detail: { version: VERSION, productBox, safeZone: safeBox }
        }));
      };
      image.src = url;
    };

    const updateSide = (side) => {
      const url = imageFor(side) || imageFor('front');
      setHref(preview, url);
      preview.dataset.ufProductSide = side;
      updateLayout(url);
      designer.dispatchEvent(new CustomEvent('uf:product-canvas-change', { bubbles:true, detail:{ side, version:VERSION } }));
    };

    sideButtons.forEach((button) => button.addEventListener('click', () => requestAnimationFrame(() => updateSide(button.dataset.ufSide || 'front'))));
    viewButtons.forEach((button) => button.addEventListener('click', () => {
      const mode = button.dataset.ufProductView || 'product';
      root.dataset.ufProductView = mode;
      viewButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    }));
    opacity?.addEventListener('input', () => root.style.setProperty('--uf-product-opacity', String(Number(opacity.value || 90) / 100)));
    updateSide(sideButtons.find((b) => b.classList.contains('is-active'))?.dataset.ufSide || 'front');
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-uf-personalization-side]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => boot(), { once:true }) : boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
